export type ReportingLimitedFlag = {
  hiddenWhenReportingLimited?: boolean;
};

export const withReportingLimit = <T extends object>(
  items: T[]
): Array<T & { hiddenWhenReportingLimited: true }> =>
  items.map((item) => ({ ...item, hiddenWhenReportingLimited: true as const }));

export const isHiddenUnderReportingLimit = (
  limited: boolean,
  item: ReportingLimitedFlag
): boolean => limited && !!item.hiddenWhenReportingLimited;
